export const routes = {
  phished: {
    reportMail: '/emails/reports/client',
    secureBeforeYouClick: '/phished-assistant/secure-before-you-click',
    testLinks: '/phished-assistant/test-links',
    configuration: '/phished-assistant/configuration',
    // TODO: replace later
    reportFalsePositive: '/fake/route',
  },
  zim: {
    health: '/up',
  },
  office: {
    deleteMail: (mailId: string, userEmail: string) =>
      `/users/${encodeURIComponent(userEmail)}/messages/${mailId}`,
    getMailMIME: (mailId: string, userEmail: string) =>
      `/users/${encodeURIComponent(userEmail)}/messages/${mailId}/$value`,
    moveMailToSpam: (mailId: string, userEmail: string) =>
      `/users/${encodeURIComponent(userEmail)}/messages/${mailId}/move`,
    getMailParentFolder: (mailId: string, userEmail: string) =>
      `/users/${encodeURIComponent(userEmail)}/messages/${mailId}?$select=parentFolderId`,
    translateExchangeIds: (userEmail: string) =>
      `/users/${encodeURIComponent(userEmail)}/translateExchangeIds`,
  },
  accessTokenValidator: {
    validate: '/validate',
  },
};
